import { render, staticRenderFns } from "./eComplaintManageModal.vue?vue&type=template&id=29712c35"
import script from "./eComplaintManageModal.vue?vue&type=script&lang=js"
export * from "./eComplaintManageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports